var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivelog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active_log",
    "data-name": "Active log",
    transform: "translate(-5367 -13325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_227_",
    transform: "translate(5351.259 13325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_228_",
    d: "M35.741,7.038H32.787V4.324L27.733,0H15.741V20H32.787V17.189h2.954Zm-1.826,8.485H21.13V8.7H33.915Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_231_",
    d: "M129.336,185.99h-1.77v-2.88h-.675v3.471h2.444Z",
    transform: "translate(-104.293 -172.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_232_",
    d: "M171.007,185.645a1.7,1.7,0,0,0,.533.4,1.577,1.577,0,0,0,.692.149,1.6,1.6,0,0,0,.68-.144,1.693,1.693,0,0,0,.538-.386,1.8,1.8,0,0,0,.352-.557,1.756,1.756,0,0,0,.127-.662,1.787,1.787,0,0,0-.122-.645,1.86,1.86,0,0,0-.342-.567,1.717,1.717,0,0,0-.53-.4,1.525,1.525,0,0,0-.687-.154,1.6,1.6,0,0,0-.68.144,1.7,1.7,0,0,0-.54.389,1.834,1.834,0,0,0-.357.562,1.743,1.743,0,0,0-.13.665,1.837,1.837,0,0,0,.467,1.215Zm.284-1.638a1.185,1.185,0,0,1,.193-.372.965.965,0,0,1,.318-.264.99.99,0,0,1,.858,0,.958.958,0,0,1,.318.257,1.2,1.2,0,0,1,.2.372,1.354,1.354,0,0,1,.071.435,1.389,1.389,0,0,1-.066.423,1.188,1.188,0,0,1-.2.374.986.986,0,0,1-.318.266.984.984,0,0,1-.86,0,.983.983,0,0,1-.318-.259,1.159,1.159,0,0,1-.2-.372,1.4,1.4,0,0,1,0-.858Z",
    transform: "translate(-145.187 -172.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_236_",
    d: "M237.636,185.677a1.625,1.625,0,0,0,.523.376,1.533,1.533,0,0,0,.643.137,1.327,1.327,0,0,0,.968-.416v.391h.557v-1.784H239.07v.494h.7v.244a1.183,1.183,0,0,1-.909.474.93.93,0,0,1-.408-.09,1.006,1.006,0,0,1-.325-.247,1.161,1.161,0,0,1-.215-.369,1.313,1.313,0,0,1-.078-.457,1.382,1.382,0,0,1,.071-.445,1.2,1.2,0,0,1,.2-.372.945.945,0,0,1,.313-.254.88.88,0,0,1,.4-.093,1.014,1.014,0,0,1,.516.137.935.935,0,0,1,.369.4l.5-.372a1.329,1.329,0,0,0-.526-.552,1.627,1.627,0,0,0-.838-.205,1.606,1.606,0,0,0-.67.139,1.712,1.712,0,0,0-.535.376,1.762,1.762,0,0,0-.486,1.225,1.877,1.877,0,0,0,.13.7A1.8,1.8,0,0,0,237.636,185.677Z",
    transform: "translate(-207.685 -172.522)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivelog);
export default __webpack_public_path__ + "static/media/Activelog.4974220bd62f9c2c8608f5147ee17075.svg";
export { ForwardRef as ReactComponent };